/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Tournaments_DescriptionInputs */



/**
* | output |
* | --- |
* | "Run tournaments with pods, deck check, and judges all under one event." |
*
* @param {Nav_Locked_Tournaments_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_tournaments_description = /** @type {((inputs?: Nav_Locked_Tournaments_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Tournaments_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstalte Turniere mit Pods, Deck-Check und Judges in einem Event.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisez des tournois avec pods, contrôle de deck et arbitres dans un seul événement.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("在同一场赛事中管理分组、卡组检查与裁判，办好你的比赛。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("在同一場賽事中管理多人桌、牌堆檢查與裁判，舉辦你的賽事。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("팟, 덱 점검, 심판을 하나의 대회에서 운영하세요.")
	return /** @type {LocalizedString} */ ("Run tournaments with pods, deck check, and judges all under one event.")
});